module.exports = __webpack_public_path__ + "static/media/test12_4.1116bd50.png";